<template>
  <v-dialog
    v-model="active"
    persistent
    width="25%"
  >
    <template #activator="{ on, attrs }">
      <ASecondaryButton
        label="Editar"
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <ACard>
      <v-card-title class="justify-center">
        Registro de dato laboral
      </v-card-title>
      <v-card-text>
        <v-form>
          <ATextField
            v-model="datoLaboral.empresa"
            label="Empresa"
          />
          <ATextField
            v-model="datoLaboral.puesto"
            label="Puesto"
          />
          <ATextField
            v-model="datoLaboral.periodo"
            label="Período"
          />
          <ATextField
            v-model="datoLaboral.motivoConclusion"
            label="Motivo de conclusión"
          />
        </v-form>
      </v-card-text>
      <v-card-actions class="justify-center">
        <ASecondaryButton
          label="Cancelar"
          @click="closeDialog()"
        />
        <APrimaryButton
          label="Guardar"
          :loading="loading"
          :disabled="loading"
          @click="triggerSaveDatoLaboral()"
        />
      </v-card-actions>
    </ACard>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import ACard from '../atoms/ACard.vue';
import APrimaryButton from '../atoms/APrimaryButton.vue';
import ASecondaryButton from '../atoms/ASecondaryButton.vue';
import ATextField from '../atoms/ATextField.vue';

export default {
  components: {
    APrimaryButton,
    ACard,
    ATextField,
    ASecondaryButton,
  },

  props: {
    updateData: {
      type: Object,
      default: () => null,
    },

    id: {
      type: [Number, String],
      required: true,
    },
  },

  data() {
    return {
      active: false,
      datoLaboral: {
        fk_idExpediente: null,
        empresa: '',
        puesto: '',
        periodo: '',
        motivoConclusion: '',
      },
      loading: false,
    };
  },

  watch: {
    updateData: {
      handler(newValue) {
        if (newValue) {
          this.datoLaboral = { ...newValue };
        }
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions('datosLaborales', ['saveDatosLaborales', 'updateDatosLaborales']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    closeDialog() {
      this.active = false;
      if (!this.updateData) {
        this.datoLaboral = {
          fk_idExpediente: this.idExpediente,
          empresa: '',
          puesto: '',
          periodo: '',
          motivoConclusion: '',
        };
      } else {
        this.datoLaboral = { ...this.updateData };
      }
    },

    async triggerSaveDatoLaboral() {
      this.loading = true;

      try {
        if (this.updateData) {
          await this.updateDatosLaborales(this.datoLaboral);
        } else {
          this.datoLaboral.fk_idExpediente = Number(this.id);
          await this.saveDatosLaborales(this.datoLaboral);
        }
        this.SET_SNACKBAR_MESSAGE('Dato laboral guardado.');
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al guardar el dato laboral');
      }

      this.closeDialog();

      this.loading = false;
    },
  },
};
</script>
